import { createContext, useContext, useState, useCallback } from 'react'

const GlobalContext = createContext()

export function GlobalProvider({ children }) {
    const [avatar, setAvatar] = useState(null);
    const [loaderAvatar, setLoaderAvatar] = useState(false);
    const [hostResto, setHostResto] = useState([]);
    const [hostByResto, setHostBResto] = useState(null);
    const [resto, setResto] = useState(null);
    const [restoHostCount, setRestoHostCount] = useState(null);
    const [restoCountry, setRestoCountry] = useState(null);
    const [restoPosition, setRestoPosition] = useState(null);
    const [restoLikes, setRestoLikes] = useState(null);
    const [restoCountNotifys, setRestoCountNotifys] = useState(null);
    const [restoEvaluation, setRestoEvaluation] = useState([]);
    const [restoRanking, setRestoRanking] = useState(null);
    const [chatMessages, setChatMessages] = useState([]);
    const [points, setPoints] = useState(null);
    const [pointsLoader, setPointsLoader] = useState(false);
    const [infoHost, setInfoHost] = useState(null);
    const [checkInHost, setCheckIn] = useState(null);
    const [ranking, setRanking] = useState([]);
    const [rankingLoader, setRankingLoader] = useState(false);
    const [hostPosition, setHostPosition] = useState(null);
    const [messagesNoRead, setMessagesNoRead] = useState([])
    const [messagesNoReadLength, setMessagesNoReadLength] = useState(0)
    const [hostActive, setHostActive] = useState(false);
    const [openModalTerms, setOpenModalTerms] = useState(false);
    const [ceoRestoHost, setCeoRestoHost] = useState([])
    const [ownerRestaurants, setOwnerRestaurants] = useState([]);
    const [ownerRestaurantsLoading, setOwnerRestaurantsLoading] = useState(false);
    const [ownerRestaurantsLoaded, setOwnerRestaurantsLoaded] = useState(false);
    const [selectedOwnerRestaurantId, setSelectedOwnerRestaurantId] = useState("");

    const resetGlobalState = useCallback(() => {
        setAvatar(null);
        setLoaderAvatar(false);
        setHostResto([]);
        setHostBResto(null);
        setResto(null);
        setRestoHostCount(null);
        setRestoCountry(null);
        setRestoPosition(null);
        setRestoLikes(null);
        setRestoCountNotifys(null);
        setRestoEvaluation([]);
        setRestoRanking(null);
        setChatMessages([]);
        setPoints(null);
        setPointsLoader(false);
        setInfoHost(null);
        setCheckIn(null);
        setRanking([]);
        setRankingLoader(false);
        setHostPosition(null);
        setMessagesNoRead([]);
        setMessagesNoReadLength(0);
        setHostActive(false);
        setOpenModalTerms(false);
        setCeoRestoHost([]);
        setOwnerRestaurants([]);
        setOwnerRestaurantsLoading(false);
        setOwnerRestaurantsLoaded(false);
        setSelectedOwnerRestaurantId("");
    }, []);

    return (
        <GlobalContext.Provider
            value={{
                loaderAvatar, setLoaderAvatar,
                avatar, setAvatar,
                hostResto, setHostResto,
                hostByResto, setHostBResto,
                resto, setResto,
                restoHostCount, setRestoHostCount,
                restoCountry, setRestoCountry,
                restoPosition, setRestoPosition,
                restoLikes, setRestoLikes,
                restoCountNotifys, setRestoCountNotifys,
                restoEvaluation, setRestoEvaluation,
                restoRanking, setRestoRanking,
                chatMessages, setChatMessages,
                points, setPoints,
                pointsLoader, setPointsLoader,
                infoHost, setInfoHost,
                checkInHost, setCheckIn,
                ranking, setRanking,
                rankingLoader, setRankingLoader,
                hostPosition, setHostPosition,
                messagesNoRead, setMessagesNoRead,
                messagesNoReadLength, setMessagesNoReadLength,
                hostActive, setHostActive,
                openModalTerms, setOpenModalTerms,
                ceoRestoHost, setCeoRestoHost,
                ownerRestaurants, setOwnerRestaurants,
                ownerRestaurantsLoading, setOwnerRestaurantsLoading,
                ownerRestaurantsLoaded, setOwnerRestaurantsLoaded,
                selectedOwnerRestaurantId, setSelectedOwnerRestaurantId,
                resetGlobalState,
            }}
        >
            {children}
        </GlobalContext.Provider>
    )
}

export const useGlobalContext = () => useContext(GlobalContext)
